import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";

import { GlobalContext } from "../../context/GlobalState";

import { getImageURL } from "../../utils/url";
import { fixname, decodeHTMLEntities, fixUrl } from "../../utils/tools";

export default function Resources({ showClass, showLang = true }) {
  const {
    userDetails,
    assignedSubjects,
    setUserDetails,
    sectionId,
    setSectionId,
    setSelectedClass,
    lang,
    setLanguage,
    selectedClass,
    assignedGrades,
  } = useContext(GlobalContext);

  const handleSelectClass = (grade) => {
    const sectionId = grade.subjects.length && grade.subjects[0].sectionId;
    setSectionId(sectionId);
    localStorage.setItem("currentsectionId", sectionId);
    localStorage.setItem("gradeSection", grade._id);
    setSelectedClass(grade._id);
  };

  return (
    <>
      <div className={`${assignedGrades?.loading ? "d-none" : ""}`}>
        {/* Language Buttons - Top Right */}
        {showLang && (
          <div className="d-flex gap-4 justify-content-end mb-2">
            <button
              type="button"
              className={`language_button fw-bold me-2 ${
                lang === "english" ? "selected_language" : ""
              }`}
              id="english_button"
              onClick={() => setLanguage("english")}
            >
              ENGLISH
            </button>

            <button
              type="button"
              className={`language_button fw-bold ${
                lang === "hindi" ? "selected_language" : ""
              }`}
              id="hindi_button"
              onClick={() => setLanguage("hindi")}
            >
              HINDI
            </button>
          </div>
        )}

        {/* Class Buttons - Center */}
        {showClass && (
          <div className="d-flex flex-wrap justify-content-center gap-2">
            {assignedGrades.grades.map((grade) => {
              const selected = grade._id === selectedClass;

              return (
                <button
                  key={grade._id}
                  type="button"
                  onClick={() => handleSelectClass(grade)}
                  className="btn fw-bold rounded-pill"
                  style={{
                    backgroundColor: selected ? "#5ce0d2" : "#e6fbf8",
                    color: selected ? "#fff" : "#00897b",
                    border: "2px solid #5ce0d2",
                    padding: "6px 22px",
                    minWidth: "55px",
                    transition: "all 0.2s ease",
                  }}
                >
                  {grade._id}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {assignedGrades.loading ? (
        <div className="text-center">
          <CircularProgress style={{ color: "#FF075B", fontWeight: "600" }} />
        </div>
      ) : (
        <div className="row mt-1 mb-3 gy-4">
          {assignedSubjects[0]
            ? assignedSubjects[0]
                .filter((asub) => asub?.subjectData?.lang === lang)
                .sort((s1, s2) => {
                  return s1?.subjectData?.priority - s2?.subjectData?.priority;
                })
                .map((assignedSubject, index) => (
                  <div
                    className="col-sm-2 cardBox"
                    key={index}
                    onClick={() =>
                      setUserDetails({
                        ...userDetails,
                        pathName: {
                          subjectName: `${decodeHTMLEntities(
                            assignedSubject.subject,
                          )}`,
                          chapterName: "",
                          topicName: "",
                        },
                      })
                    }
                    style={{
                      display: assignedSubject?.subjectData?.disabled
                        ? "none"
                        : "block",
                    }}
                  >
                    <NavLink
                      to={{
                        pathname: `/myresources/${decodeHTMLEntities(
                          fixname(assignedSubject.subject),
                        )}/${
                          assignedSubject.subjectId
                        }?sectionId=${sectionId}&gradeName=${selectedClass}`,
                      }}
                      style={{
                        marginBottom: "3rem",
                        textDecoration: "none",
                      }}
                    >
                      <div className="card card-radius card-height boxShadowCard">
                        <div className="card-img">
                          <img
                            src={getImageURL(
                              fixUrl(assignedSubject?.subjectData?.thumbnail),
                            )}
                            className="card-thumbnail"
                            alt={assignedSubject?.subject || "chapter"}
                          />
                        </div>
                        <div className="text-center">
                          <h5 style={{ fontWeight: "bold", color: "#808080" }}>
                            {decodeHTMLEntities(
                              assignedSubject?.subjectData?.name || "",
                            )}
                          </h5>
                          <p className="text-dark">
                            {"Chapters "}
                            {assignedSubject.subjectData?.totalChapters || 0}
                          </p>
                        </div>
                      </div>
                      {/* </div> */}
                    </NavLink>
                  </div>
                ))
            : null}
        </div>
      )}
    </>
  );
}
